import { makeAutoObservable } from 'mobx';
import { ObstacleType } from '../config';

export class Obstacle {
    _id = null;
    _closetid = null;
    _pageNo = null;
    _scaleOnPdf = 1;
    _obstacleType = ObstacleType.RECTANGLE;
    _data = {};

    constructor(id, closetId, pageNo, scale, data, type) {
        makeAutoObservable(this);
        this._id = id;
        this._closetid = closetId;
        this._pageNo = pageNo;
        this._scaleOnPdf = scale;
        this._data = data;
        this._obstacleType = type;
    }

    get id() {
        return this._id;
    }

    get coordinates() {
        return this._coordinates;
    }

    get pageNo() {
        return this._pageNo;
    }

    get scaleOnPdf() {
        return this._scaleOnPdf;
    }

    get closetId() {
        return this._closetid;
    }

    get obstacleType() {
        return this._obstacleType;
    }

    get data() {
        return this._data;
    }

    setClosetId(closetId) {
        this._closetid = closetId;
    }

    setObstacleType(type) {
        this._obstacleType = type;
    }

    addCoordinate(coordinate) {
        this._coordinates.push(...coordinate);
    }

    setData(data) {
        this._data = data;
    }

    isObstacleInTol(coordinate, scale) {
        const x = coordinate.x;
        const y = coordinate.y;
        const cX = this.data.coordinate.x;
        const cY = this.data.coordinate.y;
        if (!this.data.radius) {
            const width = this.data.width / scale;
            const height = this.data.height / scale;
            if (
                x >= cX - width &&
                x <= cX + width &&
                y >= cY - height &&
                y <= cY + height
            ) {
                return true;
            }
        } else {
            const radius = this.data.radius;
            if (
                x >= cX - radius &&
                x <= cX + radius &&
                y >= cY - radius &&
                y <= cY + radius
            ) {
                return true;
            }
        }
        return false;
    }

    findObstacleByCoordinate(coordinate) {
        const x = coordinate.x;
        const y = coordinate.y;
        const cX = this.data.coordinate.x;
        const cY = this.data.coordinate.y;
        if (!this.data.radius) {
            const width = this.data.width;
            const height = this.data.height;
            if (
                x >= cX - width / 2 &&
                x <= cX + width / 2 &&
                y >= cY - height / 2 &&
                y <= cY + height / 2
            ) {
                return this;
            }
        } else {
            const radius = this.data.radius;
            if (
                x >= cX - radius &&
                x <= cX + radius &&
                y >= cY - radius &&
                y <= cY + radius
            ) {
                return this;
            }
        }
        return null;
    }

    updateObstacleCoordinate(coordinate) {
        this._data.coordinate.x = coordinate.x;
        this._data.coordinate.y = coordinate.y;
    }
}
